const selectKyc = (state) => state.kyc;
export const selectKycData = (state) => selectKyc(state).data;
export const selectKycTotal = (state) => selectKyc(state).total;
export const selectPlayerAttachments = (state) => state.playerAttachments;
const selectPlayerAttachmentsHistory = (state) => state.playerAttachmentsHistory;
export const selectPlayerAttachmentsHistoryData = (state) => selectPlayerAttachmentsHistory(state).data;
export const selectPlayerAttachmentsHistoryTotal = (state) => selectPlayerAttachmentsHistory(state).total;
